var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bem-window',{staticStyle:{"max-width":"1400px","margin":"auto"},attrs:{"id":_vm.$route.params.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }